import Signal from 'libs/signals';

const searchBusinessResultsSignal = Signal({
  businesses: [],
  dropdownFilters: {},
  modalOpen: false,
  selectedBusiness: null,
  totalPages: 0,
  totalCount: 0,
  recordsPerPage: 20,
});

export default searchBusinessResultsSignal;
